<template>
  <div class="gallery">
    <div class="gallery__nav">
      <nav-popup v-if="isMobile" :itemList="navList" :active="active" @select="onSelect" />
      <nav-list v-else :itemList="navList" :active="active" @select="onSelect" />
    </div>

    <gallery-list :itemList="selectedGalleryList" />
  </div>
</template>

<script>
import NavList from '../shared/NavList'
import NavPopup from '../shared/NavPopup'
import GalleryList from './GalleryList'
// utils
import { loadImage } from '@/utils'

export default {
  components: {
    NavList,
    NavPopup,
    GalleryList
  },
  data () {
    return {
      galleryList: [],
      active: 0
    }
  },
  computed: {
    navList () {
      return this.galleryList.map(item => item.name)
    },
    isMobile () {
      return this.$mq.resize && this.$mq.below(this.$mv.lg)
    },
    selectedGalleryList () {
      const list = this.galleryList[this.active]
      return list ? list.items : []
    }
  },
  watch: {
    galleryList (val) {
      this.onLoadGallery(val)
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.$http.static.get('/data/gallery.json')
        .then((response) => {
          this.galleryList = response.data
        }, (error) => {
          console.error(error)
        }).catch(() => null)
    },
    onSelect (index) {
      this.active = index
    },
    onLoadGallery (list) {
      list.forEach(gallery => {
        loadImage(gallery.items, 'full2x')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.gallery {
  &__nav {
    margin-bottom: 50px;

    @include media-breakpoint-up(lg) {
      display: flex;
      justify-content: center;
      margin-bottom: 60px;
    }
  }
}
</style>
